<template>
  <a-modal
    title="修改位置或球衣号"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :destroyOnClose="true"
    okText="提交"
    cancelText="取消"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="队员头像" :label-col="labelCol" :wrapper-col="wrapperCol">
        <Upload ref="upload" :imgs="imgs" @uploadSuccess="uploadSuccess" :fixedNumber="[5, 7]" :disabled="true"></Upload>
      </a-form-item>
      <a-form-item label="球衣号" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input-number
          placeholder="请输入球衣号"
          :min="0"
          :max="100"
          style="width: 100%;"
          v-decorator="['shirtNumber',{ rules: [{ required: true, message: '请输入球衣号' }], initialValue: player.jerseyNumber }]" />
      </a-form-item>
      <a-form-item label="场上位置" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="programId == 4 || programId == 5">
        <a-select
          placeholder="请选择位置"
          v-decorator="['location',{ rules: [{ required: true, message: '请选择位置' }], initialValue: player.location }]">
          <a-select-option v-for="item in locationList" :value="item.title" :key="item.title">{{ item.title }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="场上位置" :label-col="labelCol" :wrapper-col="wrapperCol" v-else>
        <a-input placeholder="请选择位置" v-decorator="['location',{ rules: [{ required: true, message: '请选择位置' }], initialValue: player.location }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import Upload from '@comm/upload/Upload'
export default {
  components: {
    Upload
  },
  data () {
    return {
      matchFun,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      imgs: [],
      editPlayer: null,
      programId: this.$route.query.programId,
      player: {
        head: null,
        jerseyNumber: null,
        location: null
      },
      locationList: []
    }
  },
  methods: {
    show (player) {
      this.visible = true
      this.editPlayer = player
      this.player.head = player.head
      this.player.jerseyNumber = player.jerseyNumber
      this.player.location = player.location
      this.imgs = [this.matchFun.randomNumFile('playerHead.jpg', player.head)]
      this.initLocationList()
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            agencyId: this.$route.query.agencyId,
            teamId: localStorage.getItem('teamId'),
            cardId: this.editPlayer.cardId,
            location: values['location'],
            jerseyNumber: values['shirtNumber'],
            programId: this.$route.query.programId
          }
          this.confirmLoading = true
          this.$api.join.updateLocation(params).then(res => {
            if (res.status === 0) {
              this.$message.success('修改成功')
              this.editPlayer.location = params.location
              this.editPlayer.jerseyNumber = params.jerseyNumber
              this.handleCancel()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            console.log('err', err)
            this.$message.error('修改失败')
          }).finally(_ => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.player = {
        head: null,
        jerseyNumber: null,
        location: null
      }
      this.editPlayer = null
      this.imgs = []
    },
    uploadSuccess (fileList) {
      this.imgs = fileList
      if (fileList.length > 0) {
        this.player.head = fileList[0].url
      } else {
        this.player.head = null
      }
    },
    initLocationList () {
      if (this.$route.query.programId === 4) {
        this.locationList = [{title: '中锋'}, {title: '左中峰'}, {title: '左边锋'}, {title: '右中锋'}, {title: '右边锋'}, {title: '中前锋'}, {title: '左前锋'}, {title: '右前锋'},
          {title: '前腰'}, {title: '左前腰'}, {title: '右前腰'}, {title: '中中场'}, {title: '左中中场'}, {title: '左中场'}, {title: '左边中场'}, {title: '右中中场'}, {title: '右中场'},
          {title: '右边中场'}, {title: '后腰'}, {title: '左后腰'}, {title: '右后腰'}, {title: '中后卫'}, {title: '左中后卫'}, {title: '左后卫'}, {title: '左边后卫'}, {title: '右中后卫'},
          {title: '右后卫'}, {title: '右边后卫'}, {title: '清道夫'}, {title: '守门员'}]
      } else {
        this.locationList = [
          {title: '控球后卫'}, {title: '得分后卫'}, {title: '小前锋'}, {title: '大前锋'}, {title: '中锋'}
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/EditPlayer.vue